// extracted by mini-css-extract-plugin
export default {"root_items":"PersonalAppointment_root_items__a8P0D","root_items_doctors":"PersonalAppointment_root_items_doctors__IA3qq"};